export default /* @ngInject */ function($mdThemingProvider) {

    // https://angular-md-color.com
    // #ffaa77
    let oranje = {
        50: '#ffd686',
        100: '#ffcd6d',
        200: '#ffc453',
        300: '#ffbb3a',
        400: '#ffb320',
        500: 'ffaa07',
        600: '#ec9b00',
        700: '#d38b00',
        800: '#b97a00',
        900: '#a06900',
        A100: '#ffdea0',
        A200: '#ffe7b9',
        A400: '#fff0d3',
        A700: '#865800',
        contrastDefaultColor: 'light'
    };
    $mdThemingProvider.definePalette('oranje', oranje);

    let coal = {
        50: '#404040',
        100: '#333333',
        200: '#262626',
        300: '#1a1a1a',
        400: '#0d0d0d',
        500: '#000',
        600: '#000000',
        700: '#000000',
        800: '#000000',
        900: '#000000',
        A100: '#4d4d4d',
        A200: '#595959',
        A400: '#666666',
        A700: '#000000'
    };
    $mdThemingProvider.definePalette('coal', coal);


    $mdThemingProvider.theme('bprTheme')
        .primaryPalette('oranje')
        .accentPalette('coal')
        .warnPalette('red');

    $mdThemingProvider.setDefaultTheme('bprTheme');
}



// WEBPACK FOOTER //
// ./config/material-theme.js